export const getNoticeUrl = (baseUrl: string) => {
  // 공지사항 (알림X)
  const noticeUrl = `${baseUrl}/notices`

  return {
    NOTICE_LIST: noticeUrl,
    NOTICE_DETAIL: (noticeId: number) => `${noticeUrl}/${noticeId}`,
    NOTICE_READ_ALL: `${noticeUrl}/read-all`
  }
}
